var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "-3 -1 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6169 8.86486H9.47507V5.67578H6.26239V8.86486H4.12061L7.86873 12.5854L11.6169 8.86486ZM7.33328 9.92788V6.73881H8.40417V9.92788H9.03065L7.86873 11.0813L6.70681 9.92788H7.33328ZM4.12061 13.6485H11.6169V14.7115H4.12061V13.6485Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6774 0H2.10422C0.946897 0 0 0.940909 0 2.09091V16.7273C0 17.8773 0.946897 18.8182 2.10422 18.8182H13.6774C14.8347 18.8182 15.7816 17.8773 15.7816 16.7273V2.09091C15.7816 0.940909 14.8347 0 13.6774 0ZM13.6774 16.7273H2.10422V2.09091H13.6774V16.7273Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDownload);
export default __webpack_public_path__ + "static/media/card-download.f0bb6c45ddd5abe6f06cd636793891bf.svg";
export { ForwardRef as ReactComponent };